import React, { useCallback } from 'react'
import { FieldHookConfig, useField } from 'formik'
import { RadioGroup as UIRadioGroup } from '@carsys/ui'
import { isInvalid } from './utils'
import { useFormSection } from './FormSection'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface RadioGroupProps
  extends Omit<React.ComponentProps<typeof UIRadioGroup>, 'defaultChecked' | 'defaultValue' | 'name' | 'value'>,
    Pick<FieldHookConfig<any>, 'name' | 'validate'> {}

export function RadioGroup({ children, name, validate, onBlur, ...props }: RadioGroupProps) {
  const [input, meta, helpers] = useField({ name, validate })
  useRegisterFormField(name)
  const formSection = useFormSection()

  // create a new blur handler, resolves warnings for blur events when nesting other form fields in a radio group
  const blurHandler = useCallback(
    e => {
      helpers.setTouched(true)
      onBlur?.(e)
    },
    [onBlur]
  )

  return (
    <UIRadioGroup
      error={isInvalid(meta)}
      disabled={formSection.disabled}
      {...props}
      {...input}
      helperText={isInvalid(meta) ? meta.error : props.helperText}
      onBlur={blurHandler}
    >
      {children}
    </UIRadioGroup>
  )
}
